import { render } from "./Banner.vue?vue&type=template&id=31c910cc&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=31c910cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31c910cc"

export default script